import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { Modal } from "app/components/Modal";
import React from "react";
import { useTranslation } from "react-i18next";

import { useAddPriceQuoteModal } from "../../hooks/useAddPriceQuoteModal";
import PriceQuoteFields from "./PriceQuoteFields";
import { useStyles } from "./styles";

type Props = {
  open: boolean;
  onClose: () => void;
};

const AddPriceQuoteModal = ({ open, onClose }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const modal = useAddPriceQuoteModal(onClose);

  return (
    <Modal open={open} onClose={modal.close}>
      <Box className={styles.modal}>
        <Box className={styles.header}>
          <Typography className={styles.title}>
            {t("QUOTES.MODAL.ADD_TITLE")}
          </Typography>
          <IconButton
            className={styles.closeButton}
            onClick={modal.close}
            aria-label={t("BUTTONS.CANCEL")}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.body}>
          <PriceQuoteFields modal={modal} />
        </Box>

        <Box className={styles.footer}>
          <Button
            className={styles.cancelButton}
            variant="outlined"
            onClick={modal.close}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            className={styles.addButton}
            variant="contained"
            disableElevation
            disabled={!modal.isValid}
            onClick={modal.submit}
          >
            {t("BUTTONS.ADD")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddPriceQuoteModal;
